(function() {
	'use strict';
	$(document).ready(function() {
		// Typeahead
		$.typeahead({
			input: 'input[name="s"].search-field',
			minLength: 3,
			maxItem: 0,
			dynamic: true,
			group: {
				key: "category",
				template: function(item) {
					var result =
					'<span class="group"><i class="fal fa-lightbulb-on mr-2"></i>' +
						item.category +
						'<span class="count">(' +
							item.category_count +
						')</span>' +
					'</span>';
					if (item.category_link && item.category_link.length > 0) {
						result +=
						'<a class="show-all" href="' + item.category_link + '" title="Alle anzeigen">' +
							'<span class="d-none d-sm-inline-block">' +
								'<i class="fal fa-long-arrow-alt-right mr-2"></i>Alle anzeigen' +
							'</span>' +
						'</a>';
					}
					return result;
				}
			},
			source: {
				category: {
					filter: false,
					// Array of Objects / Strings
					ajax: {
						url: "/ajax/suche",
						type: "post",
						data: {
							"input": "{{query}}"
						}
					}
				}
			},
			delay: 100,
			searchOnFocus: true,
			// mustSelectItem: true,
			template: '<span class="result">{{display}}</span>',
			emptyTemplate: function (query) {
				if (query.length > 0) {
					return '<span title="Keine Treffer">Keine Treffer für „' + query + '“</span>';
				}
			},
			callback: {
				onClick: function (node, a, item, event) {
					window.location = item.link;
				},
				onLayoutBuiltBefore: function (node, query, result, resultHtmlList) {
					if (resultHtmlList && result.length > 0) {
						return resultHtmlList.append(
							$('<li />', { "class": "typeahead__item"}).append(
								$('<a/>', {
									"text": "Alle Treffer für „" + query + "“ anzeigen",
									"href": "/suche?s=" + query
								})
							)
						);
					}
				},
				onLayoutBuiltAfter: function () {
					$('.typeahead__item').last().addClass('active');
				}
			}
		});
	});
}());